export default function Pin() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fill="var(--black-400)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.06349C12 9.3077 8 13.6667 8 13.6667C8 13.6667 4 9.3077 4 7.06349C4 4.81929 5.79086 3 8 3C10.2091 3 12 4.81929 12 7.06349ZM9.5 7.06354C9.5 7.90512 8.82843 8.58735 8 8.58735C7.17157 8.58735 6.5 7.90512 6.5 7.06354C6.5 6.22197 7.17157 5.53973 8 5.53973C8.82843 5.53973 9.5 6.22197 9.5 7.06354Z"
      />
    </svg>
  )
}
